import { API_BASE_URL } from "../../constants/index";
import { buildUrl } from "../../utilities/index";
import HttpInterface from "../../helpers/HttpInterface";

export class WarehousesService {
  constructor() {
    this.httpProxy = new HttpInterface();
  }

  all(params = {}) {
    const requestOptions = {
      method: "GET",
    };
    return this.httpProxy.fetch(
      buildUrl(`${API_BASE_URL}/logistic-service/warehouses`, params),
      requestOptions
    );
  }

  get(id) {
    const requestOptions = {
      method: "GET",
    };
    return this.httpProxy.fetch(
      API_BASE_URL + `/logistic-service/warehouses/${id}`,
      requestOptions
    );
  }

  create(warehouse) {
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(warehouse),
    };
    return this.httpProxy.fetch(
      API_BASE_URL + `/logistic-service/warehouses`,
      requestOptions
    );
  }

  edit(warehouse) {
    const requestOptions = {
      method: "PUT",
      body: JSON.stringify(warehouse),
    };
    return this.httpProxy.fetch(
      API_BASE_URL + `/logistic-service/warehouses/${warehouse.id}`,
      requestOptions
    );
  }

  delete(id) {
    const requestOptions = {
      method: "DELETE",
    };
    return this.httpProxy.fetch(
      API_BASE_URL + `/logistic-service/warehouses/${id}`,
      requestOptions
    );
  }
}
